class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector('.collection');
      if (collectionElement) {
        collectionElement.classList.add('loading');
      }
    }
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }


  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderSearchResultsCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderSearchResultsCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newProductGridContainer = parsedHTML.getElementById('ProductGridContainer');
    if (!newProductGridContainer) return;
    
    productGridContainer.innerHTML = newProductGridContainer.innerHTML;

    productGridContainer
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const productCountElement = parsedHTML.getElementById('ProductCount');
    if (!productCountElement) return;
    
    const count = productCountElement.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderSearchResultsCount(html) {
    if (!FacetFiltersForm.isSearchPage()) return;
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const resultsCountElement = parsedHTML.querySelector('.template-search__results-count');
    if (!resultsCountElement) return;
    
    const domResultsCount = document.querySelector('.template-search__results-count');
    if (domResultsCount) {
      domResultsCount.innerHTML = resultsCountElement.innerHTML;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
      const jsFilter = event.target.closest('.js-filter');
      if (jsFilter && jsFilter.id) {
        const closestJSFilterID = jsFilter.id;
        FacetFiltersForm.renderCounts(countsToRender, jsFilter);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const domElement = document.querySelector(selector);
      if (domElement) {
        domElement.innerHTML = activeFacetsElement.innerHTML;
        
        const allFacetRemoves = activeFacetsElement.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)');
        const hasActiveFilters = Array.from(allFacetRemoves).some((facetRemove) => {
          const paramName = facetRemove.getAttribute('data-param-name');
          return paramName !== 'filter.v.availability';
        });
        const clearButtonWrapper = domElement.querySelector('.active-facets__button-wrapper');
        if (clearButtonWrapper) {
          clearButtonWrapper.style.display = hasActiveFilters ? '' : 'none';
        }
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const element = document.querySelector(selector);
      if (element) {
        element.innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const activeFacetsInHtml = html.querySelector('.active-facets-mobile, .active-facets-desktop');
      if (activeFacetsInHtml) {
        const allFacetRemoves = activeFacetsInHtml.querySelectorAll('facet-remove:not(.active-facets__button-wrapper):not(.mobile-facets__clear-wrapper)');
        const hasActiveFilters = Array.from(allFacetRemoves).some((facetRemove) => {
          const paramName = facetRemove.getAttribute('data-param-name');
          return paramName !== 'filter.v.availability';
        });
        const clearButtonInDrawer = mobileForm.querySelector('.mobile-facets__clear-wrapper');
        if (clearButtonInDrawer) {
          clearButtonInDrawer.style.display = hasActiveFilters ? '' : 'none';
        }
      }
      
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      }
    }
  }

  static isSearchPage() {
    return window.location.pathname.includes('/search') || 
           document.querySelector('.template-search') !== null ||
           document.getElementById('main-search-filters') !== null;
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    try {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    } catch (e) {
      /* Evita erro em cadeia se history foi wrapped por analytics (unwrap is not a function). */
    }
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return [];
    
    let sectionId = productGrid.dataset.id;
    if (!sectionId && productGrid.parentElement) {
      sectionId = productGrid.parentElement.dataset.id;
    }
    
    if (!sectionId) return [];
    
    return [
      {
        section: sectionId,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  hasActiveFilters(searchParams) {
    if (!searchParams) return false;
    
    const params = new URLSearchParams(searchParams);
    const filterParams = [];
    
    for (const [key, value] of params) {
      if (key.startsWith('filter.') && key !== 'filter.v.availability') {
        filterParams.push(key);
      }
      if (['q', 'tag', 'vendor', 'type'].includes(key)) {
        filterParams.push(key);
      }
    }
    
    return filterParams.length > 0;
  }

  onSubmitForm(searchParams, event) {
    let cleanedParams = searchParams.replace(/&?filter\.v\.availability=1/g, '');
    
    if (this.hasActiveFilters(cleanedParams)) {
      if (cleanedParams && !cleanedParams.endsWith('&')) {
        cleanedParams += '&';
      }
      cleanedParams += 'filter.v.availability=1';
    }
    
    FacetFiltersForm.renderPage(cleanedParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const isMobileCheckbox = event.target && event.target.classList.contains('mobile-facets__checkbox');
    const isSearchPage = FacetFiltersForm.isSearchPage();
    
    if (isMobileCheckbox) {
      if (isSearchPage) {
        const forms = [];
        sortFilterForms.forEach((form) => {
          if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event);
      } else {
        const searchParams = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(searchParams, event);
      }
    } else {
      const forms = [];
      const isMobile = event.target.closest('form') && event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let searchParams =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    let cleanedParams = searchParams.replace(/&?filter\.v\.availability=1/g, '');
    
    if (this.hasActiveFilters(cleanedParams)) {
      if (cleanedParams && !cleanedParams.endsWith('&')) {
        cleanedParams += '&';
      }
      cleanedParams += 'filter.v.availability=1';
    }
    
    FacetFiltersForm.renderPage(cleanedParams);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('facet-filters-form');
  if (form) {
    const hasFilters = form.hasActiveFilters(window.location.search.slice(1));
    
    const activeFacetsDesktop = document.querySelector('.active-facets-desktop');
    if (activeFacetsDesktop) {
      const clearButtonDesktop = activeFacetsDesktop.querySelector('.active-facets__button-wrapper');
      if (clearButtonDesktop) {
        const allFacetRemoves = activeFacetsDesktop.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)');
        const hasActiveFiltersDesktop = Array.from(allFacetRemoves).some((facetRemove) => {
          const paramName = facetRemove.getAttribute('data-param-name');
          return paramName !== 'filter.v.availability';
        });
        clearButtonDesktop.style.display = hasActiveFiltersDesktop ? '' : 'none';
      }
    }
    
    const activeFacetsMobile = document.querySelector('.active-facets-mobile');
    if (activeFacetsMobile) {
      const clearButtonMobile = activeFacetsMobile.querySelector('.active-facets__button-wrapper');
      if (clearButtonMobile) {
        const allFacetRemoves = activeFacetsMobile.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)');
        const hasActiveFiltersMobile = Array.from(allFacetRemoves).some((facetRemove) => {
          const paramName = facetRemove.getAttribute('data-param-name');
          return paramName !== 'filter.v.availability';
        });
        clearButtonMobile.style.display = hasActiveFiltersMobile ? '' : 'none';
      }
    }
    
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const clearButtonInDrawer = mobileForm.querySelector('.mobile-facets__clear-wrapper');
      if (clearButtonInDrawer) {
        clearButtonInDrawer.style.display = hasFilters ? '' : 'none';
      }
    }
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (typeof event.key === 'string' && !event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) customElements.define('facet-remove', FacetRemove);

class ColumnSelector extends HTMLElement {
  constructor() {
    super();

    this.loadDesktopColumns();
    this.loadMobileColumns();
    document.querySelector('.product-grid-container .collection')?.classList.remove('hidden');

    new MutationObserver(() => {
      this.loadDesktopColumns();
      this.loadMobileColumns();
      document.querySelector('.product-grid-container .collection')?.classList.remove('hidden');
    }).observe(document.querySelector('.product-grid-container'), { childList: true, subtree: true });
  }

  loadDesktopColumns() {
    const grid = document.querySelector('#product-grid');
    const buttonsDesktop = this.querySelectorAll('.column-button-desktop');
    const savedDesktopColumns = localStorage.getItem('desktopColumns') || '3';

    if (grid) {
      grid.classList.remove('grid--3-col-desktop', 'grid--5-col-desktop');
      grid.classList.add(`grid--${savedDesktopColumns}-col-desktop`);
    }

    buttonsDesktop.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.columns === savedDesktopColumns);
    });

    buttonsDesktop.forEach(button => {
      button.addEventListener('click', function () {
        buttonsDesktop.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        if (grid) {
          grid.classList.remove('grid--3-col-desktop', 'grid--5-col-desktop');
          grid.classList.add(`grid--${this.dataset.columns}-col-desktop`);
        }
        localStorage.setItem('desktopColumns', this.dataset.columns);
      });
    });
  }

  loadMobileColumns() {
    const grid = document.querySelector('#product-grid');
    const buttonsMobile = this.querySelectorAll('.column-button-mobile');
    const savedMobileColumns = localStorage.getItem('mobileColumns') || '2';

    if (grid) {
      grid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');
      grid.classList.add(`grid--${savedMobileColumns}-col-tablet-down`);
    }

    buttonsMobile.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.columns === savedMobileColumns);
    });

    buttonsMobile.forEach(button => {
      button.addEventListener('click', function () {
        buttonsMobile.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        if (grid) {
          grid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');
          grid.classList.add(`grid--${this.dataset.columns}-col-tablet-down`);
        }
        localStorage.setItem('mobileColumns', this.dataset.columns);
      });
    });
  }
}

if (!customElements.get('column-selector')) customElements.define('column-selector', ColumnSelector);

class PaginationElement extends HTMLElement {
  constructor() {
    super();

    if (document.querySelector('.load-more')) {
      PaginationElement.loadInfiniteScroll();
    }
  }

  static loadInfiniteScroll() {
    const loadMoreBtn = $('.load-more__btn');
    const productGrid = $('#product-grid');
    const loadMoreSpinner = $('.load-more__spinner');
    const noMoreProducts = $('.no-more-products');
    var nextUrl = productGrid.data('next-url');

    if (!nextUrl) {
      loadMoreBtn.hide();
    } else {
      loadMoreBtn.show();
    }

    loadMoreBtn.on('click', function (e) {
      e.stopImmediatePropagation();

      const productGrid = $('#product-grid');
      nextUrl = productGrid.data('next-url');

      $.ajax(
        {
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          beforeSend: function () {
            loadMoreBtn.hide();
            loadMoreSpinner.show();
          }
        }
      )
        .done(function (products) {
          const newProducts = $(products).find('#product-grid');
          const nextPage = newProducts.data('next-url');
          const productGrid = $('#product-grid');

          productGrid.data('next-url', nextPage);
          productGrid.append(newProducts.html());

          if (nextPage) {
            loadMoreBtn.show();
            loadMoreSpinner.hide();
            noMoreProducts.hide();
          } else {
            loadMoreBtn.hide();
            loadMoreSpinner.hide();
            noMoreProducts.show();
          }
        })
    })
  }
}

if (!customElements.get('pagination-element')) customElements.define('pagination-element', PaginationElement);